import { AUTH_VISUAL } from '../constants/auth'

export function AuthIllustration() {
  return (
    <aside className="auth-aside" aria-hidden="true">
      <div className="auth-aside__art">
        <svg
          className="auth-aside__svg"
          viewBox="0 0 360 420"
          xmlns="http://www.w3.org/2000/svg"
          role="img"
        >
          <defs>
            <linearGradient id="authPot" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#c4a484" />
              <stop offset="100%" stopColor="#8d6e4c" />
            </linearGradient>
            <linearGradient id="authLeaf" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#3d8b66" />
              <stop offset="100%" stopColor="#1b4332" />
            </linearGradient>
            <linearGradient id="authPetal" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#f4b4c4" />
              <stop offset="100%" stopColor="#d46a8a" />
            </linearGradient>
            <linearGradient id="authGift" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#f0c14b" />
              <stop offset="100%" stopColor="#d4a017" />
            </linearGradient>
          </defs>

          <ellipse cx="180" cy="378" rx="118" ry="18" fill="#1b4332" opacity="0.1" />

          {/* Plant pot */}
          <path
            d="M118 268h84l-10 78c-2 14-14 24-28 24h-8c-14 0-26-10-28-24l-10-78Z"
            fill="url(#authPot)"
          />
          <rect x="108" y="252" width="104" height="22" rx="6" fill="#a98467" />

          {/* Stems */}
          <path
            d="M168 252c2-42 18-78 42-108"
            fill="none"
            stroke="#2d6a4f"
            strokeWidth="4"
            strokeLinecap="round"
            className="auth-aside__sway"
          />
          <path
            d="M160 252c-8-36-28-62-52-78"
            fill="none"
            stroke="#2d6a4f"
            strokeWidth="3.5"
            strokeLinecap="round"
            className="auth-aside__sway auth-aside__sway--alt"
          />
          <path
            d="M176 252c8-48 4-86-8-118"
            fill="none"
            stroke="#1b4332"
            strokeWidth="4"
            strokeLinecap="round"
          />

          {/* Leaves */}
          <ellipse
            cx="118"
            cy="188"
            rx="34"
            ry="16"
            transform="rotate(-28 118 188)"
            fill="url(#authLeaf)"
            className="auth-aside__sway auth-aside__sway--alt"
          />
          <ellipse
            cx="228"
            cy="168"
            rx="38"
            ry="17"
            transform="rotate(32 228 168)"
            fill="url(#authLeaf)"
            className="auth-aside__sway"
          />
          <ellipse
            cx="148"
            cy="140"
            rx="28"
            ry="13"
            transform="rotate(-12 148 140)"
            fill="#2d6a4f"
          />

          {/* Bloom */}
          <g className="auth-aside__bloom">
            <ellipse cx="168" cy="108" rx="22" ry="14" transform="rotate(-20 168 108)" fill="url(#authPetal)" />
            <ellipse cx="188" cy="98" rx="22" ry="14" transform="rotate(18 188 98)" fill="url(#authPetal)" />
            <ellipse cx="176" cy="122" rx="20" ry="13" transform="rotate(8 176 122)" fill="#e889a4" />
            <circle cx="176" cy="108" r="10" fill="#f0b429" />
            <circle cx="176" cy="108" r="4.5" fill="#fff6d6" />
          </g>

          {/* Gift box */}
          <g className="auth-aside__gift">
            <rect x="214" y="286" width="78" height="58" rx="8" fill="url(#authGift)" />
            <rect x="246" y="286" width="14" height="58" fill="#1b4332" opacity="0.2" />
            <rect x="214" y="308" width="78" height="14" fill="#1b4332" opacity="0.18" />
            <rect x="208" y="274" width="90" height="18" rx="5" fill="#e2b93d" />
            <path
              d="M246 274c-8-16 6-24 14-14 8-10 22-2 14 14"
              fill="none"
              stroke="#1b4332"
              strokeWidth="3"
              strokeLinecap="round"
            />
          </g>

          {/* Small hanging bloom */}
          <circle cx="112" cy="220" r="11" fill="#f4b4c4" className="auth-aside__sway--alt" />
          <circle cx="112" cy="220" r="4" fill="#f0b429" />
        </svg>
      </div>
      <div className="auth-aside__copy">
        <p className="auth-aside__title">{AUTH_VISUAL.title}</p>
        <p className="auth-aside__body">{AUTH_VISUAL.body}</p>
      </div>
    </aside>
  )
}
